import { buildUrl } from "helpers";
import { instance } from "libs/api";

import { SubChildCategory } from "../../categories.types";
import { ApiRoutesCategories } from "./../../constants";

export const requestGetCategoryById = async (
  categoryId: string
): Promise<SubChildCategory> => {
  return await instance.get(
    buildUrl(ApiRoutesCategories.CategoryWithPermissions, categoryId)
  );
};
